<template>
  <div class="solution3">
    <div class="banner">
      <div>
        <h3>现代农业产业园数字化解决方案</h3>
        <p>
          构建现代农业产业园线上+线下混合发展的数字化新模式，通过数字平台建设，聚集研发、生产、服务、销售、物流、金融、深加工等产业上下游企业形成具有地方优势、全国特色的线上产业集群，打造“产业CBD”
        </p>
      </div>
    </div>
    <div class="container">
      <img src="@/assets/mob/images/solution/c_3.jpg" alt />
    </div>
    <div class="d_footer1">
      <h3>现代农业产业园建设五大任务</h3>
      <van-grid :border="false" :column-num="2">
        <van-grid-item class="li">
          <div class="img"></div>
          <p>做大做强主导产业，建设乡村产业兴旺引领区</p>
        </van-grid-item>
        <van-grid-item class="li">
          <div class="img"></div>
          <p>促进生产要素集聚，建设现代技术与装备集成区</p>
        </van-grid-item>
        <van-grid-item class="li">
          <div class="img"></div>
          <p>推进产加销、贸工农一体化发展，建设一二三产融合发展区</p>
        </van-grid-item>
        <van-grid-item class="li">
          <div class="img"></div>
          <p>推进适度规模经营，建设新型经营主体创业创新孵化区</p>
        </van-grid-item>
      </van-grid>
      <div class="li last">
        <div class="img"></div>
        <p>提升农业质量效益和竞争力，建设高质量发展示范区</p>
      </div>
    </div>

    <div class="d_footer2">
      <h3>现代农业产业园建设的七大内容</h3>

      <van-grid :border="false" :column-num="3" gutter="20">
        <van-grid-item class="li">
          <img src="~@/assets/pc/images/solution/sec5_11.jpg" alt="" />
          <p>做大做强主导产业</p>
        </van-grid-item>
        <van-grid-item class="li">
          <img src="~@/assets/pc/images/solution/sec5_12.jpg" alt="" />
          <p>同步推进一二三产融合</p>
        </van-grid-item>
        <van-grid-item class="li">
          <img src="~@/assets/pc/images/solution/sec5_13.jpg" alt="" />
          <p>聚集关键生产要素</p>
        </van-grid-item>
        <van-grid-item class="li">
          <img src="~@/assets/pc/images/solution/sec5_14.jpg" alt="" />
          <p>推进绿色循环发展</p>
        </van-grid-item>
        <van-grid-item class="li">
          <img src="~@/assets/pc/images/solution/sec5_15.jpg" alt="" />
          <p>推进适度规模经营</p>
        </van-grid-item>
        <van-grid-item class="li">
          <img src="~@/assets/pc/images/solution/sec5_16.jpg" alt="" />
          <p>创新完善工作机制</p>
        </van-grid-item>
      </van-grid>
      <div class="li">
        <img src="~@/assets/pc/images/solution/sec5_17.jpg" alt="" />
        <p>科学合理规划布局</p>
      </div>
    </div>

    <div class="d_footer3">
      <div
        class="button"
        @click="
          show = true
          systemId = '3'
        "
      >
        获取最新解决方案
        <i class="el-icon-arrow-right"></i>
      </div>
    </div>
    <Dialog
      :show="show"
      :systemId="systemId"
      @close="show = false"
      title="获取最新解决方案"
    />
  </div>
</template>
<script>
import Dialog from './components/dialog'
export default {
  components: { Dialog: Dialog },
  data() {
    return {
      systemId: '3',
      show: false,
    }
  },
}
</script>
<style lang="scss">
@import '~@/assets/mob/css/solution.scss';
</style>
